// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router, { useRouter } from 'next/router';
import Breadcrumbs from '@/components/breadcrumbs';
import Tabs from '@/components/tabs';
import Fetch from '@/utils/Fetch';
import ToastContext from '@/utils/toast-context';
import Helper from '@/utils/helper';
import Attachments from '@/components/shared-views/attachments';
import Communications from '@/components/shared-views/communications';
import Jobs from '@/components/shared-views/jobs';
import Quotes from '@/components/shared-views/quotes';
import Invoices from '@/components/shared-views/invoices';
import PurchaseOrders from '@/components/shared-views/purchases';
import Appointments from '@/components/shared-views/appointments';
import Timers from '@/components/job/timers';
import ProjectDetails from '@/components/project/project-details';
import * as Enums from '@/utils/enums';
import ConfirmAction from '@/components/modals/confirm-action';
import Storage from '@/utils/storage';
import PS from '@/services/permission/permission-service';
import ProjectService from '@/services/project/project-service';
import {Box, Button, Card, Flex, Text, Tooltip} from "@mantine/core";
import ToolbarButtons from "@/PageComponents/Button/ToolbarButtons";
import {IconCheck, IconDotsVertical} from "@tabler/icons";
import {useElementSize} from "@mantine/hooks";
import ProjectJobsTable from "@/PageComponents/Table/Component Tables/ProjectJobsTable";
import ItemQuotesTable from "@/PageComponents/Table/Component Tables/ItemQuotesTable";
import ItemInvoicesTable from "@/PageComponents/Table/Component Tables/ItemInvoicesTable";
import ItemPurchasesTable from "@/PageComponents/Table/Component Tables/ItemPurchasesTable";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import { showNotification } from '@mantine/notifications';
import QuoteDrawer from "@/PageComponents/Quote/QuoteDrawer";
import InvoiceDrawer from "@/PageComponents/Invoice/InvoiceDrawer";
import { createFileRoute } from '@tanstack/react-router'

function ProjectPage() {

  const router = useRouter();
  const { id, tab } = router.query;
  const queryClient = useQueryClient();
 // TODO(tanstack-router): verify router.query → useParams/useSearch

  const { data: projectData } = useQuery(
    ['project', id],
    () => Fetch.get({ url: '/Project/' + id }),
    { enabled: !!id }
  );

  const { data: customerData } = useQuery(
    ['customer', projectData?.CustomerID],
    () => Fetch.get({ url: '/Customer/' + projectData.CustomerID }),
    { enabled: !!projectData?.CustomerID }
  );

  const toast = useContext(ToastContext);

  const [quotePermission] = useState(PS.hasPermission(Enums.PermissionName.Quote));
  const [appointmentPermission] = useState(PS.hasPermission(Enums.PermissionName.Appointment));
  const [invoicePermission] = useState(PS.hasPermission(Enums.PermissionName.Invoice));
  const [purchaseOrderPermission] = useState(PS.hasPermission(Enums.PermissionName.PurchaseOrder));

  const [pageTabs, setPageTabs] = useState<any[]>([]);

  const [selectedTab, setSelectedTab] = useState<any>(null);
  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  const [project, setProject] = useState<any>(null);
  const [appointments, setAppointments] = useState<any[]>([]);
  const [timers, setTimers] = useState<any[]>([]);

  const [customer, setCustomer] = useState<any>(null);
  const [contacts, setContacts] = useState<any[]>([]);
  const [contact, setContact] = useState<any>(null);
  const [locations, setLocations] = useState<any[]>([]);
  const [location, setLocation] = useState<any>(null);

  const [employee, setEmployee] = useState<any>(null);

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  function updateProject(field: any, value: any, orKeyValues: any) {
    let newProjectState = { ...project };

    if (orKeyValues && orKeyValues.length > 0) {
      orKeyValues.map((item: any) => {
        newProjectState[item.key] = item.value;
      });
    }
    if (field) {
      newProjectState[field] = value;
    }

    setProject(newProjectState);
    setFormIsDirty(true);
  }

  // OPTION BUTTONS

  const [optionButtons, setOptionButtons] = useState<any[]>([]);

  const { data: openJobsForProject, isLoading: openJobsLoading, isFetching: openJobsFetching } = useQuery(
    ['project', id, 'openJobs'],
    () => Fetch.post({
      url: '/Job/GetJobsForProject',
      params: {
        projectId: project.ID,
        IncludeClosed: false,
        pageSize: 1,
        pageIndex: 0,
      }
    }),
    { enabled: !!project?.ID && !project?.IsClosed }
  );
  const openJobsCount = typeof openJobsForProject?.TotalResults === 'number'
    ? openJobsForProject.TotalResults
    : (openJobsForProject?.Results?.length ?? 0);
  const hasOpenJobs = openJobsCount > 0;
  const openJobsUnknown = !!project?.ID && !project?.IsClosed && (openJobsLoading || openJobsFetching || openJobsForProject === undefined);

  const {data: companyDetails} = useQuery(['companyDetails'], () => Fetch.get({url: '/Company'}))
  const [selectedQuote, setSelectedQuote] = useState<any>(null)
  const [createNewQuote, setCreateNewQuote] = useState(false)
  const [createNewCopyQuote, setCreateNewCopyQuote] = useState<any>(null)
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null)
  const [createNewInvoice, setCreateNewInvoice] = useState(false)
  const [createNewCopyInvoice, setCreateNewCopyInvoice] = useState<any>(null)

  const getOptionButtons = () => {
    let opts = [];
    if (quotePermission)
      opts.push({ text: 'Create Quote', link: `CreateQuote` });
    if (invoicePermission)
      opts.push({ text: 'Create Invoice', link: 'CreateInvoice' });
    if (purchaseOrderPermission)
      opts.push({ text: 'Create Purchase Order', link: 'CreatePurchaseOrder' });

    setOptionButtons(opts);
  };

  const optionsClick = (link: any) => {
    switch (link) {      
      case 'CreateQuote':
        setCreateNewQuote(true)
        break;
      case 'CreateInvoice':
        setCreateNewInvoice(true)
        break;
      case 'CreatePurchaseOrder':
        Helper.nextRouter(Router.push, `/purchase/create?module=${Enums.Module.Project}&moduleID=${project.ID}&supplierID=${null}`);
        break;
    }
  };

  const [closing, setClosing] = useState(false);

  const closeProject = async() => {
    setClosing(true);
    try {
       const openJobsRes = await Fetch.post({
         url: '/Job/GetJobsForProject',
         params: {
           projectId: project.ID,
           IncludeClosed: false,
           pageSize: 100,
           pageIndex: 0,
         }
       });
       const hasErrorStatus =
         openJobsRes?.status === false ||
         openJobsRes?.status === 'error' ||
         openJobsRes?.ResponseStatus === false ||
         openJobsRes?.ResponseStatus === 'error' ||
         openJobsRes?.ResponseStatus?.ErrorCode ||
         openJobsRes?.ResponseStatus?.Message;
       if (hasErrorStatus) {
         showNotification({
           message:
             openJobsRes?.ResponseStatus?.Message ||
             openJobsRes?.message ||
             'Unable to verify open jobs for this project. Please try again.',
           color: 'red',
           autoClose: 8000,
         });
         return;
      }
    const openJobs = openJobsRes?.Results ?? [];
    const totalOpenJobs =
    typeof openJobsRes?.TotalResults === 'number'
        ? openJobsRes.TotalResults
        : openJobs.length;

    if (openJobs.length > 0) {
      const displayJobs = openJobs.slice(0, 5);
      showNotification({
        message: <span>Unable to close project while you have {totalOpenJobs} open jobs linked to the project.</span>,
        color: 'red',
        autoClose: 8000,
      });
      return;
    }

    const result = await ProjectService.closeProject(project.ID);
    if (result?.ID) {
      showNotification({
        message: 'Project closed successfully',
        color: 'green',
        autoClose: 4000,
      });
      queryClient.invalidateQueries(['project', id]);
      setProject(result);
      getOptionButtons();
      return;
    }

    showNotification({
      message: result?.Message || result?.message || 'Unable to close project. Please try again.',
      color: 'red',
      autoClose: 8000,
    });
  }
  catch (error) {
    showNotification({
      message: 'An error occurred while closing the project. Please try again.',
      color: 'red',
      autoClose: 8000,
    });
  }
  finally {
    setClosing(false);
  }
}
  const [jobCount, setJobCount] = useState(0);
  const [quoteCount, setQuoteCount] = useState(0);
  const [invoiceCount, setInvoiceCount] = useState(0);
  const [purchaseOrderCount, setPurchaseOrderCount] = useState(0);
  const [jobTimerCount, setJobTimerCount] = useState(0);
  const [appointmentCount, setAppointmentCount] = useState(0);
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [communicationCount, setCommunicationCount] = useState(0);

  const [countsToggle, setCountsToggle] = useState(false);

  const getCounts = async (projectId: any) => {
    let countRequest = await Fetch.get({
      url: `/Project/GetCounts?id=${projectId ?? project?.ID}`,
    });
    let result = countRequest.Results;
    setJobCount(result.find((x: any) => x.Key == 'Jobs').Value);
    setQuoteCount(result.find((x: any) => x.Key == 'Quotes').Value);
    setInvoiceCount(result.find((x: any) => x.Key == 'Invoices').Value);
    setPurchaseOrderCount(result.find((x: any) => x.Key == 'PurchaseOrders').Value);
    setJobTimerCount(result.find((x: any) => x.Key == 'JobTimers').Value);
    setAppointmentCount(result.find((x: any) => x.Key == 'Appointments').Value);
    setAttachmentCount(result.find((x: any) => x.Key == 'Attachments').Value);
    setCommunicationCount(result.find((x: any) => x.Key == 'Communication').Value);

    setCountsToggle(!countsToggle);
  };

  useEffect(() => {
    buildUpPageTabs();
  }, [countsToggle]);

  const buildUpPageTabs = () => {
    let tabs = [
      { text: 'Project Details', count: '0' },
      { text: 'Jobs', count: jobCount },
      { text: 'Timers', count: jobTimerCount }];

    if (appointmentPermission) {
      tabs.push({ text: 'Appointments', count: appointmentCount });
    }

    if (quotePermission && quoteCount > 0) {
      tabs.push({ text: 'Quotes', count: quoteCount });
    }
      
    if (invoicePermission && invoiceCount > 0) {
      tabs.push({ text: 'Invoices', count: invoiceCount });
    }

    if (purchaseOrderPermission && purchaseOrderCount > 0) {
      tabs.push({ text: 'Purchases', count: purchaseOrderCount });
    }

    tabs.push(...[
      { text: 'Attachments', count: attachmentCount },
      { text: 'Messages', count: communicationCount }
    ]);

    setPageTabs(tabs);
  }

  useEffect(() => {
    getAccessStatus();
    getOptionButtons();
  }, [project?.IsClosed, quotePermission, invoicePermission, purchaseOrderPermission, hasOpenJobs]);

  useEffect(() => {
    if (id) {
      setProject(null);
      setCustomer(null);
    }
  }, [id]);

  useEffect(() => {
    if (projectData && !project) {
      setProject(projectData);
      setContact(projectData.Contact);
      setLocation(projectData.Location);
      setEmployee(projectData.Employee);
      getCounts(projectData.ID);
      fetchTimers(undefined, projectData.ID);
      fetchAppointments(projectData.ID);
    }
  }, [projectData]);

  useEffect(() => {
    if (customerData && !customer) {
      setCustomer(customerData);
      setContacts(customerData.Contacts || []);
      setLocations(customerData.Locations || []);
    }
  }, [customerData]);

  useEffect(() => {
    if (router.isReady) {
      const tabMap = { communication: 'Messages', jobs: 'Jobs' };
      setSelectedTab(tabMap[tab] || 'Project Details');
    }
  }, [router.isReady, tab, id]);

  const onAppointmentRefresh = () => {
    getCounts();
  };

  const onAttachmentRefresh = () => {
    getCounts();
  };

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  useEffect(() => {
    switch (selectedTab) {
      case 'Appointments':
        fetchAppointments();
        break;
      case 'Timers':
        fetchTimers();
        break;
      default:
        break;
    }
  }, [selectedTab]);

  // TIMERS  

  const fetchTimers = async (force: any, projectId: any) => {
    const idToUse = projectId ?? project?.ID;
    if (timers.length == 0 || force === true) {
      try {
        const timersRes = await Fetch.get({
          url: '/Project/GetJobTimes',
          params: {
            ProjectId: idToUse,
          }
        });
        setTimers(timersRes.Results);
      } catch (e) {

      }
    }
  };

  // APPOINTMENTS  

  const fetchAppointments = async (projectId: any) => {
    const idToUse = projectId ?? project?.ID;
    if (appointments.length == 0) {
      const appointmentsRes = await Fetch.get({
        url: '/Appointment/GetProjectAppointments',
        params: {
          ProjectId: idToUse
        }
      });
      setAppointments(appointmentsRes.Results);
    }
  };

  const [inputErrors, setInputErrors] = useState<any>({});

  const validate = () => {

    let validationItems = [];
    validationItems = [
      { key: 'Description', value: project.Description, required: true, type: Enums.ControlType.Text },
      { key: 'StartDate', value: project.StartDate, required: true, type: Enums.ControlType.Date },
      { key: 'Employee', value: employee, required: true, type: Enums.ControlType.Custom },
      { key: 'Budget', value: project.Budget, gte: 0, type: Enums.ControlType.Number },
      { key: 'Contact', value: contact, required: true, type: Enums.ControlType.Custom },
    ];

    const { isValid, errors } = Helper.validateInputs(validationItems);
    setInputErrors(errors);
    return isValid;
  };

  const [saving, setSaving] = useState(false);

  const [triggerSaveComment, setTriggerSaveComment] = useState(0);
  async function submitComment() {
    setTriggerSaveComment((x: any) => x + 1);
  }

  const saveProject = async () => {

    setSaving(true);

    let isValid = validate();
    if (isValid) {

      await submitComment();

      const params = {...project}
      if (location?.ID) {
        params.Location = {
          ...location
        }
        params.LocationID = location.ID
        params.LocationDisplay = location?.LocationDisplay
        params.LocationDescription = location?.Description
      }

      const projectPut = await Fetch.put({
        url: '/Project',
        params
      });

      if (projectPut.ID) {
        toast.setToast!!!({
          message: 'Project saved successfully',
          show: true,
          type: 'success'
        });
        setProject(projectPut);
        setFormIsDirty(false);
      }
    } else {
      toast.setToast!!!({
        message: 'There are errors on the page',
        show: true,
        type: Enums.ToastType.error
      });
    }

    setSaving(false);
    return isValid;
  };

  const {height: headerHeight, ref: headerRef} = useElementSize()

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, saveProject);

  if (!project) return null;

  return (
    <Box>

      <QuoteDrawer
          customerID={!!createNewCopyQuote ? undefined : customer?.ID}
          module={!!createNewCopyQuote ? undefined : Enums.Module.Project}
          moduleID={!!createNewCopyQuote ? undefined : project.ID}
          quote={selectedQuote}
          isNew={createNewQuote}
          show={createNewQuote || !!selectedQuote}
          onClose={
            () => {
              setSelectedQuote(null)
              setCreateNewQuote(false)
              setCreateNewCopyQuote(null)
            }
          }
          onSaved={(q: any) => {
            getCounts()
          }}
          onCreated={(q: any, close: any) => {
            if(!close) {
              setSelectedQuote(q)
            }
            setCreateNewQuote(false)
            setCreateNewCopyQuote(null)
            getCounts()
          }}
          accessStatus={accessStatus}
          company={companyDetails}
          copyFromQuote={createNewCopyQuote}
          onCopyToQuote={(q: any) => {
            setCreateNewQuote(true)
            setSelectedQuote(null)
            setCreateNewCopyQuote(q)
          }}
          onCreateNew={
            () => {
              setCreateNewQuote(true)
              setSelectedQuote(null)
              setCreateNewCopyQuote(null)
            }
          }
          setIsNew={setCreateNewQuote}
      />

      <InvoiceDrawer
          customerID={!!createNewCopyInvoice ? undefined : customer?.ID}
          module={!!createNewCopyInvoice ? undefined : Enums.Module.Project}
          moduleID={!!createNewCopyInvoice ? undefined : project.ID}
          invoice={selectedInvoice}
          isNew={createNewInvoice}
          show={createNewInvoice || !!selectedInvoice}
          onClose={
            () => {
              setSelectedInvoice(null)
              setCreateNewInvoice(false)
              setCreateNewCopyInvoice(null)
            }
          }
          onSaved={(q: any) => {
            getCounts()
          }}
          onCreated={(q: any, close: any) => {
            if(!close) {
              setSelectedInvoice(q)
            }
            setCreateNewInvoice(false)
            setCreateNewCopyInvoice(null)
            getCounts()
          }}
          accessStatus={accessStatus}
          company={companyDetails}
          copyFromInvoice={createNewCopyInvoice}
          onCopyToInvoice={(q: any) => {
            setCreateNewInvoice(true)
            setSelectedInvoice(null)
            setCreateNewCopyInvoice(q)
          }}
          onCreateNew={
            () => {
              setCreateNewInvoice(true)
              setSelectedInvoice(null)
              setCreateNewCopyInvoice(null)
            }
          }
          setIsNew={setCreateNewInvoice}
      />

      <Box ref={headerRef} px={'sm'} mt={'sm'}>
        <Flex justify={'space-between'} wrap={'wrap'}>

          <Flex align={'center'}>
            <Breadcrumbs currPage={{ text: project.ProjectNumber ? project.ProjectNumber : 'Project', link: '/project/' + project.ID, type: 'project-show' }} />
            {project.IsClosed && (
              <Flex align={'center'} gap={'xs'} ml={'md'}>
                <Box
                  style={{
                    width: 16,
                    height: 16,
                    borderRadius: '50%',
                    backgroundColor: 'var(--mantine-color-teal-9)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <IconCheck size={10} color="white" stroke={4} />
                </Box>
                <Text size="sm">This project is closed</Text>
              </Flex>
            )}
          </Flex>

          <ToolbarButtons align={'center'} buttonGroups={[[
            {
              type: 'custom',
              show: !project?.IsClosed,
              children: (
                <Tooltip
                  label={'Close all jobs before closing the project'}
                  disabled={!hasOpenJobs}
                  color={'scBlue'}
                  position={'bottom'}
                  withArrow
                  maw={380}
                  events={{ hover: true, focus: true, touch: true }}
                  withinPortal
                  multiline
                >
                  <Box>
                    <Button
                      variant={'outline'}
                      color={'scBlue'}
                      disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess || hasOpenJobs || openJobsUnknown || closing}
                      loading={closing}
                      onClick={closing ? undefined : closeProject}
                      data-pw={'close-project'}
                    >
                      {closing ? 'Closing' : 'Close Project'}
                    </Button>
                  </Box>
                </Tooltip>
              ),
            },
            {
              type: 'menu',
              disabled: accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess,
              action: optionsClick,
              text: "Options",
              icon: <IconDotsVertical />,
              breakpoint: 500,
              legacyOptions: optionButtons,
            },
            {
              type: 'button',
              disabled: accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess,
              isBusy: saving,
              text: saving ? "Saving" : "Save",
              onClick: saving ? null : saveProject,
            }
          ]]} />
          {/*<div className="actions">

          <ButtonDropdown disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
            action={optionsClick}
            text="Options"
            options={optionButtons}
          />

          <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
            text={saving ? "Saving" : "Save"} onClick={saving ? null : saveProject} extraClasses="w9" />
        </div>*/}
        </Flex>
        <Tabs
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            tabs={pageTabs}
            tabsProps={{mt: {base: 7, lg: 0}}}
            useNewTabs
        />
      </Box>

      <Box
          bg={'gray.1'}
          py={{base: 5, xs: 8, sm: 'md'}}
          px={{base: 5, xs: 8}}
          mih={`calc(100vh - ${(headerHeight ? (headerHeight + 58) : 166)}px)`}
      >
        <Card
            p={'md'}
            px={{base: 1, xs: 5, sm: 'sm'}}
            radius={'md'}
        >
          {(() => {
            switch (selectedTab) {
              case 'Project Details':
                return <ProjectDetails
                    project={project}
                    updateProject={updateProject}
                    customer={customer}
                    setCustomer={setCustomer}
                    contact={contact}
                    setContact={setContact}
                    contacts={contacts}
                    setContacts={setContacts}
                    location={location}
                    setLocation={setLocation}
                    locations={locations}
                    setLocations={setLocations}
                    employee={employee}
                    setEmployee={setEmployee}
                    triggerSaveComment={triggerSaveComment}
                    inputErrors={inputErrors}
                    accessStatus={accessStatus}
                />;
              case 'Jobs':
                return <ProjectJobsTable  module={Enums.Module.Project} projectId={project.ID} customerID={customer?.ID} accessStatus={accessStatus} />
              case 'Quotes':
                return <ItemQuotesTable module={Enums.Module.Project} itemId={project.ID} customerId={customer?.ID} onUpdated={getCounts} />;
              case 'Invoices':
                return <ItemInvoicesTable module={Enums.Module.Project} itemId={project.ID} customerId={customer?.ID} />;
              case 'Purchases':
                return <ItemPurchasesTable module={Enums.Module.Project} itemId={project.ID} customerId={customer?.ID}  />;
              case 'Appointments':
                return <Appointments topMargin={false} module={Enums.Module.Project} moduleID={project.ID} customerID={customer?.ID} accessStatus={accessStatus} onRefresh={onAppointmentRefresh} />;
              case 'Timers':
                return <Timers topMargin={false} timers={timers} setTimers={setTimers} project={project} accessStatus={accessStatus} refreshTimers={fetchTimers} />;
              case 'Attachments':
                return <Attachments topMargin={false} displayName={project.Description} itemId={project.ID} module={Enums.Module.Project} onRefresh={onAttachmentRefresh}
                                    accessStatus={accessStatus} />;
              case 'Messages':
                return <Communications topMargin={false} itemId={project.ID} module={Enums.Module.Project} customerID={customer?.ID} selectedContact={contact} accessStatus={accessStatus} />;
            }
          })()}
        </Card>
      </Box>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      <style jsx>{`
          .row {
            display: flex;
          }
          .actions {
            display: flex;
            min-width: 256px;
            position: relative;
          }
          .actions :global(.button){
            margin-left: 0.5rem;
            margin-top: 0;
            white-space: nowrap;
          }
      `}</style>
    </Box>
  )
}

export default ProjectPage;

export const Route = createFileRoute('/_authenticated/project/$id')({ component: ProjectPage })
